import { render, staticRenderFns } from "./BecamePatron.vue?vue&type=template&id=44bc8ce5&scoped=true&"
import script from "./BecamePatron.vue?vue&type=script&lang=js&"
export * from "./BecamePatron.vue?vue&type=script&lang=js&"
import style0 from "./BecamePatron.vue?vue&type=style&index=0&id=44bc8ce5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bc8ce5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PatronAvatar: require('/home/bitrix/frontend/components/forms/PatronAvatar.vue').default,Button: require('/home/bitrix/frontend/components/other/Button.vue').default})
